import { stats } from '@/mocks/home';

export default function HeroSpread() {
  return (
    <section className="w-full px-4 md:px-8 pt-10 md:pt-16 pb-10 md:pb-14">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b-2 border-foreground-950 pb-3">
        <span className="text-xs md:text-sm font-label tracking-[0.3em] text-primary-600">封面 · 本期特辑</span>
        <span className="text-xs font-label tracking-[0.2em] text-foreground-500">2026 秋季刊 · 总第 092 期</span>
      </div>

      <div className="mt-8 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-0">
        <div className="lg:col-span-7 lg:pr-14 anim-rise">
          <p className="text-xs font-label tracking-[0.25em] text-accent-700">黑料导航 · 合集 · 索引</p>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl lg:text-[3.4rem] font-black leading-[1.18] text-foreground-950">
            把散落各处的黑料，
            <br />
            按人物与事件整理成一条线
          </h2>
          <p className="mt-6 max-w-2xl text-sm md:text-base leading-7 md:leading-8 text-foreground-700">
            17.cn黑料导航汇总多方来源，按人物与事件整理成合集。想看17.cn黑料大全或查找特定索引，从导航入口进入，快速定位目标内容。持续整理，每日更新。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#entries"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-compass-3-line" />
              </span>
              进入导航入口
            </a>
            <a
              href="#feed"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-foreground-300 px-6 py-3 text-sm font-label text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap cursor-pointer"
            >
              查看今日快讯
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </a>
          </div>
          <p className="mt-7 text-xs md:text-sm font-label text-foreground-500">
            更新至 2026.09.12 20:02 · 已归档 92 期 · 索引 1,284 条
          </p>
        </div>

        <div className="lg:col-span-5 lg:pl-14 lg:border-l lg:border-background-300">
          <figure className="anim-rise anim-rise-2">
            <div className="w-full h-[300px] md:h-[430px] overflow-hidden rounded-lg bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20still%20life%20of%20layered%20paper%20columns%20and%20folded%20newsprint%20in%20warm%20cream%2C%20deep%20vermillion%20and%20muted%20amber%20tones%2C%20soft%20directional%20studio%20light%20casting%20gentle%20shadows%2C%20subtle%20film%20grain%2C%20minimal%20geometric%20composition%20on%20a%20plain%20uncluttered%20warm%20background&width=1000&height=1250&seq=mag17-hero-001&orientation=portrait"
                alt="17.cn黑料导航 纸本索引封面"
                title="17.cn黑料导航 封面 纸本索引"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <figcaption className="mt-3 flex items-center gap-3 text-xs font-label text-foreground-500">
              <span className="h-px flex-1 bg-background-300" />
              本期封面 · 纸本索引
            </figcaption>
          </figure>
        </div>
      </div>

      <div className="mt-10 md:mt-16 grid grid-cols-2 md:grid-cols-4 border-t border-background-300">
        {stats.map((item, i) => (
          <div
            key={item.label}
            className={[
              'px-2 py-5 md:py-7',
              i % 2 === 1 ? 'border-l border-background-300' : '',
              i >= 2 ? 'border-t border-background-300 md:border-t-0' : '',
              i > 0 ? 'md:border-l md:border-background-300' : '',
            ].join(' ')}
          >
            <div className="font-heading text-2xl md:text-4xl font-black text-foreground-950">{item.value}</div>
            <div className="mt-1 text-xs md:text-sm font-label tracking-wide text-foreground-600">{item.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}